<template>
  <div class="activity">
    <tab-list :tabList="tabBar" @tabClick="tabClick" :cur="activeTab"></tab-list>
    <div class="scroll">
      <scroll v-if="orderArr.length" :data="orderArr" :allLoaded="allLoaded" @pulldown="loadData" @loadUp="loadup">
        <div class="list_box" @click="goDetail(item.id)" v-for="(item,index) in orderArr" :key="index">
          <!-- item  时间跟状态显示 -->
          <div class="list_box_top">
            <span class="createTimeCN">{{item.createTime}}</span>
            <div class="rightBox">
              <span v-if="item.status == 0 && item.payType != 6" class="time_last">剩余时间：{{item.lastPayTime | lastPayTime}}</span>
              <span v-if="item.status == 0 && item.payType == 6" class="time_last">线下确认剩余：{{item.lastPayTime | lastPayTime}}</span>
              <span class="right_order_status">{{item | numToText}}</span>
            </div>
          </div>
          <!-- item 中间数据展示 -->
          <div class="list_box_center">
            <img class="logo" :src="item.imgUrl">
            <div class="center_right_box">
              <p class="center_right_title">{{item.materialName}}</p>
              <p :class="['label',item.serviceType==0?'':'more_time']">{{item.serviceType | serviceType}}</p>
              <p class="time_date">数量:{{item.orderNum}}</p>
              <p class="total_title">¥ {{item.payAmount | priceFormat}}</p>
            </div>
          </div>
          <!-- item 底部按钮 -->
          <div class="list_box_bottom">
            <template v-if="item.status == 0">
              <span class="cancel" @click.stop="cancelOrderByOrderId(index)">取消订单</span>
              <span class="evaluate_btn pay_btn" v-if="item.payType != 6" @click.stop="goPayCenter(item,index)">立即支付</span>
            </template>
            <span v-if="item.status != 0 && item.status != 5 && item.serviceType==0 || (item.status !=2 && item.status !=0 && item.serviceType == 1)" class="evaluate_btn">查看详情</span>
            <!-- 多次送货 -->
            <template v-if="item.serviceType==1 && item.status == 2">
              <section class="paid_box">
                <section class="paid_box_top">
                  <p class="buy_num">购买数量: <span>{{item.orderNum}}</span></p>
                  <p class="last_num">剩余未送货: <span>{{item.leaveNum}}</span></p>
                </section>
                <p class="apply_btn">申请送货</p>
              </section>
              <section class="seeding_box" v-if="item.sendingNum">
                <p>有 {{item.sendingNum}} 件商品 送货中,请耐心等待</p>
                <img src="../../../assets/images/icon_arrows_green.png">
              </section>
            </template>
            <span v-if="item.status == 5 && item.isEvaluate == 0 && item.hasTemp" class="evaluate_btn" @click.stop="evaluate(item)">去评价</span>
            <span v-if="item.isEvaluate == 1" class="evaluate_btn" @click.stop="viewEvaluation(item)">查看评价</span>
          </div>
        </div>
      </scroll>
      <no-message v-if="!orderArr.length && loaded"></no-message>
    </div>
  </div>
</template>

<script>
import tabList from '../../../components/tabbar';
import Scroll from '../../../components/scroll';
import NoMessage from '../../../components/nomessage';
import util from '../../../utils/util';
import {officeupdateOrderStatusWeChat,getOfficeMaterialOrderList} from '../../../utils/api';
import { mapState } from 'vuex';
import ping from '../../../utils/pingpay.js'
export default {
  name: 'activityList',
  props: {
    selectTab: Number
  },
  components: {
    tabList,
    Scroll,
    NoMessage
  },
  filters: {
    numToText: value => {
      if(value.status == '0'){
        return '待支付'
      }else if(value.status == '1' || value.status == '3'){
        return '已取消'
      }else if(value.status == '2'){
        if(value.serviceType == '1'){
          return '已支付'
        }else{
          // 0待送货 1送货中 2送货完成
          if(value.onceSendingStatus == 1 || value.onceSendingStatus == 2){
            return '送货中'
          }else{
            return '待送货'
          }
        }
      }else if(value.status == '5'){
        return '交易完成'
      }else if(value.status == '6'){
        return '已退订'
      }else{
        return '未定义'
      }
    },
    serviceType(val){
      if(val == '0'){
        return '一次性送货'
      }else{
        return '多次送货服务'
      }
    },
    lastPayTime(val){
      console.log(val)
      return util.formatTime(new Date(val - new Date().valueOf()), 2)
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    }),
    status(){
      if(this.activeTab == '0'){
        return ''
      }else if(this.activeTab == '1'){
        return '0'
      }else if(this.activeTab == '2'){
        return '2'
      }else{
        return '5'
      }
    }
  },
  activated () {
    if (this.common.isChange && this.selectTab === 2) {
      this.$store.commit('isChange', false);
      this.getOfficeMaterialOrderList();
    }
  },
  watch: {
    $route (to, from) {
      if (this.selectTab === 2) {
        // 来源活动订单或者订单详情刷新列表
        if (
          from.name === 'myOfficeOrder' ||
          from.name === 'officeConfirmOrder' ||from.name === 'evaluateSuccess' ||
          from.name === 'evaluate'
        ) {
          this.pageSize = 1;
          this.getOfficeMaterialOrderList();
        }
      }
    }
  },
  data () {
    return {
      tabBar: ['全部', '待支付', '已支付', '交易成功'],
      orderArr: [],
      activeTab: 0,
      pageNo: 1,
      loaded: false,
      canPay:true,
      allLoaded: false
    };
  },
  created () {
    this.getOfficeMaterialOrderList()
  },
  methods: {
    viewEvaluation (item) {
      this.$router.push(`/evaluate/viewEvaluate?id=${item.id}`);
    },
    evaluate (item) {
      console.log(item);
      this.$router.push(
        `/evaluate/evaluate?id=${item.id}&referenceName=办公耗材&templateType=6&referenceNo=${item.orderNo}`
      );
    },
    goPayCenter (item,index) {
      if(!this.canPay){return;}
      this.canPay = false;
      let params = {
        orderNo: item.orderNo,
        repairNo: "", // "报修单号",
        bussinessType:"6",//会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6
        feeCode:"",
        // payType: payType, // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"6.线下支付
        channel: "wx_pub" // 渠道名
      };
      ping(params,'',() => {this.orderArr[index].status = 2});
      setTimeout(()=>{
        this.canPay = true
      },1000)
    },
    // 取消订单
    cancelOrderByOrderId (index) {
      util.showModal('', '确定要取消该订单吗？', true, '确定', () => {
        officeupdateOrderStatusWeChat({
          orderId: this.orderArr[index].id,
          status: '1',
          approve:this.common.userInfo.account || this.common.userInfo.phone
        }).then(res => {
          console.log(res)
          if (res.res.code === 10000) {
            util.showToast('已取消')
            this.orderArr[index].status = 1
          }else{
            util.showToast(res.res.msg)
          }
        })
      })
    },
    goDetail (id) {
      this.$router.push(`/myOfficeOrder?id=${id}`);
    },
    tabClick (val) {
      this.activeTab = val;
      this.pageNo = 1;
      this.getOfficeMaterialOrderList();
    },
    getOfficeMaterialOrderList(){
      this.allLoaded = false;
      let params = {
        userId: this.common.userId,
        pageNo: this.pageNo,
        status:this.status,
        pageSize: 10
      }
      getOfficeMaterialOrderList(params).then(res=>{
        this.loaded = true;
        console.log(res)
        if (res.res && res.res.code === 10000 && res.body) {
          if (res.body.officeMaterialOrderList.length !== 10) {
            this.allLoaded = true;
          }
          if (this.pageNo === 1) {
            this.orderArr = res.body.officeMaterialOrderList;
          } else {
            this.orderArr = [...this.orderArr, ...res.body.officeMaterialOrderList];
          }
        }
      })
    },
    loadup () {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.getOfficeMaterialOrderList();
    },
    loadData () {
      this.pageNo = 1;
      this.getOfficeMaterialOrderList();
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.activity {
  height: 100%;
  .flex(column);
  .scroll {
    flex: 1;
    height: 500px;
  }
}
.line {
  margin: 0 30px;
  height: 1px;
  .borderB();
}
.loading_text {
  width: 100%;
  height: 80px;
  line-height: 80px;
  color: #c9c9c9;
  .fontSize(14px);
  text-align: center;
}
.list {
  background-color: rgba(243, 244, 246, 1);
  width: 100%;
}

/*-----------中间信息列表模块---------*/
.list_box {
  background: #fff;
  margin:20px;
  border-radius:8px;
  overflow: hidden;
  // padding:20px;
}

.list_box_top {
  height: 34px;
  padding:20px;
  .flex();
  justify-content: space-between;
  align-items: center;
}

.createTimeCN {
  .fontSize(13px);
  color: @color9;
}

.rightBox {
  .flex();
  align-items: center;
  justify-content: flex-end;
}

.right_order_status {
  .fontSize(13px);
  color: @color17;
}
.list_box_center {
  .flex();
  padding:18px 20px;
}

.logo {
  width: 240px;
  height: 180px;
  margin-right: 20px;
}

.center_right_box {
  width: 410px;
}

.center_right_title {
  .fontSize(14px);
  .textOver(100%);
  color: @color3;
  line-height: 40px;
  font-weight: bold;
  margin-bottom: 10px;
}

.center_right_address {
  line-height:36px;
  background:rgba(255,240,225,1);
  border-radius:4px;
  font-size:24px;
  color:rgba(255,126,30,1);
  margin-bottom:10px;
  display: inline-block;
  padding:0 6px;
}
.label{
  padding:0 6px;
  height:36px;
  background:rgba(255,240,225,1);
  border-radius:4px;
  font-size:24px;
  margin-bottom:10px;
  color:rgba(255,126,30,1);
  line-height:36px;
  display: inline-block;
}
.more_time{
  background:#def5ed;
  color:#16bc84;
}

.time_date {
  font-size:24px;
  color:rgba(153,153,153,1);
  line-height:34px;
  margin-bottom:10px;
}

.list_box_bottom {
  .flex();
  justify-content: flex-end;
  align-items: center;
}

.buttonBox {
  .flex();
  justify-content: space-between;
  align-items: center;
}

.backPay {
  .fontSize(13px);
  display: block;
  color: @color6;
}

.time_last {
  .fontSize(12px);
  color: #fc3f56;
  line-height: 36px;
  padding: 0 14px;
  margin-right: 20px;
  background:rgba(252,63,86,0.1);
  border-radius:4px;
}

.total_title {
  line-height: 40px;
  .fontSize(14px);
  color: @color3;
  margin-top: 10px;
}

.cancel {
  width: 128px;
  height: 52px;
  border-radius: 4px;
  .border(#dadada);
  .fontSize(13px);
  color: #666666;
  line-height: 52px;
  text-align: center;
  margin-right: 20px;
  margin-bottom:20px;
  box-sizing: border-box;
}

.evaluate_btn {
  width: 128px;
  height: 52px;
  border-radius: 4px;
  border:0.015rem solid #dadada;
  .fontSize(13px);
  color: @color6;
  line-height: 52px;
  text-align: center;
  margin-right: 20px;
  margin-bottom:20px;
  box-sizing: border-box;
}
.pay_btn {
  color: @color17;
  box-sizing: border-box;
  .border(#96aaf0);
  background:rgba(243,245,253,1);
}
.paid_box{
  .flex();
  height:88px;
  padding:0 20px;
  width:100%;
  align-items: center;
  justify-content: space-between;
  .paid_box_top{
    .flex();
    flex:1;
    align-items: center;
    p{
      font-size:24px;
      color:rgba(102,102,102,1);
      margin-right:60px;
    }
    .buy_num{
      span{
        font-size:28px;
        color:#333;
      }
    }
    .last_num{
      span{
        font-size:28px;
        color:#FF7E1E;
      }
    }
  }
  .apply_btn{
    height:52px;
    line-height: 52px;
    background:rgba(22,188,132,1);
    border-radius:4px;
    font-size:26px;
    color:rgba(255,255,255,1);
    text-align: center;
    width:128px;
    text-align:center;
  }
}
.seeding_box{
  width:100%;
  padding:0 20px;
  height:76px;
  .flex();
  align-items: center;
  justify-content:space-between;
  background:#E7F8F2;
  color:#16BC84;
  font-size:24px;
  img{
    display: block;
    width:32px;
    height:32px;
  }
}
</style>
